import { render } from "./Icon.vue?vue&type=template&id=47e6a334&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=47e6a334&scoped=true&lang=css"

import exportComponent from "/builds/cloud-game/goc_backstage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e6a334"]])

export default __exports__